import { useState, useEffect } from "react";
import {
  Header,
  HeaderLeft,
  HeaderRight,
  HeaderTitle,
  HeaderTitleLine,
  HeaderRightUser,
  HeaderRightUserName,
  HeaderRightUserLevel,
  Menu,
  MenuItem,
} from "./styles";
import { Icons } from "components/Icons";
import { Hidden } from "@material-ui/core";
import { useRouter } from "hooks";
import { useSession } from "context/SessionContext";
import DialogNewPass from "../Dialogs/DialogNewPass";
import { isUpdated, resetFlag } from "services/sessionService";

interface PageHeaderProps {
  title: any;
  showUserData?: boolean;
  previousPage?: boolean;
}

export default function PageHeader({
  title,
  showUserData = true,
  previousPage,
}: PageHeaderProps) {
  const [anchorEl, setAnchorEl] = useState(false);
  const [user, setUser] = useState({} as any);
  const [modalPSW, setModalPSW] = useState(false);
  const [updated, setUpdated] = useState(false);

  const router = useRouter();
  const { signOut } = useSession();

  const handleClick = () => {
    setAnchorEl(!anchorEl);
  };

  const handleLogout = () => {
    signOut();
    router.push("/");
  };

  const handleChangePsw = () => {
    setModalPSW(true)
    getUploaded()
  }

  const getUploaded = async () => {
    try {
      await isUpdated()
        .then((res) => {
          const isUpdated = !!res.data.ISUPDATED
          setUpdated(isUpdated)
        })
    } catch (err) {
      console.log(err);
    }
  }

  const setFlag = async () => {
    try {
      await resetFlag()
        .then((res) => 
          console.log(`resetFlag: ${res?.data?.statuscode}`))
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    const getUser = localStorage.getItem("@adminModulockerCond:user") as any;
    if (getUser) {
      setUser(JSON.parse(getUser));
    }
  }, []);
  return (
    <>
      <Header style={{ marginBottom: "30px" }}>
        <HeaderLeft>
          <HeaderTitle>{title}</HeaderTitle>
          <HeaderTitleLine />
        </HeaderLeft>

        {showUserData && (
          <Hidden smDown>
            <HeaderRight onClick={handleClick}>
              <Icons.UserFilled style={{ fontSize: "32px" }} />

              <HeaderRightUser>
                <HeaderRightUserName>{user?.name}</HeaderRightUserName>
                <HeaderRightUserLevel>Administrador</HeaderRightUserLevel>
              </HeaderRightUser>

              <Icons.ExpandMore fontSize="large" />
              {anchorEl && (
                <Menu onMouseLeave={() => setAnchorEl(false)}>
                  <MenuItem onClick={handleChangePsw}>Alterar Senha</MenuItem>
                  <MenuItem onClick={() => handleLogout()}>Sair</MenuItem>
                </Menu>
              )}
            </HeaderRight>
          </Hidden>
        )}
      </Header>

      <DialogNewPass
        open={modalPSW}
        flag={updated}
        setOpen={setModalPSW}
      />
    </>
  );
}
